import React from 'react';
import { 
  FileText, 
  Search, 
  CheckCircle, 
  FileCheck, 
  CreditCard, 
  Bell, 
  Archive,
  TrendingUp,
  Shield,
  Clock
} from 'lucide-react';

const detailedProcess = [
  {
    step: '01',
    icon: FileText,
    title: 'Инициация процесса',
    subtitle: 'Фиксация обращения и анализ запроса',
    description: 'Мы получаем ваше обращение через любой удобный канал связи и мгновенно регистрируем его в нашей защищенной системе. Каждому кейсу присваивается уникальный номер для отслеживания.',
    actions: [
      'Регистрация обращения в CRM-системе с уникальным ID',
      'Назначение персонального менеджера кейса',
      'Предварительная классификация: тип мошенничества, сумма, юрисдикция',
      'Оценка первоначальных перспектив возврата'
    ],
    duration: '1 час',
    color: '#10B981'
  },
  {
    step: '02',
    icon: Search,
    title: 'Сбор и верификация данных',
    subtitle: 'Комплексный сбор доказательной базы',
    description: 'Наши эксперты собирают полную доказательную базу: все платежные документы, переписку, скриншоты, договоры и транзакции. Мы проверяем каждую деталь для построения сильнейшего кейса.',
    actions: [
      'Запрос платежных документов (чеки, банковские выписки, криптотранзакции)',
      'Сбор всей переписки с мошенниками (email, мессенджеры, звонки)',
      'Анализ договоров, офферов и условий использования',
      'Верификация аутентичности всех документов',
      'Blockchain-анализ при работе с криптовалютами'
    ],
    duration: '1-2 дня',
    color: '#F59E0B'
  },
  {
    step: '03',
    icon: CheckCircle,
    title: 'Финансовый анализ',
    subtitle: 'Глубокий аудит ситуации с точки зрения банковских процедур',
    description: 'Команда международных специалистов проводит детальный анализ вашего случая с точки зрения банковского регулирования, выявляя все нарушения и определяя оптимальную стратегию.',
    actions: [
      'Определение применимых банковских процедур и регуляторов',
      'Проверка сроков для подачи претензий и chargeback-запросов',
      'Анализ нарушений со стороны брокера/платформы',
      'Оценка перспектив через банковские процедуры возврата',
      'Проверка регуляторного статуса компании-ответчика',
      'Идентификация бенефициаров и цепочек владения'
    ],
    duration: '2-3 дня',
    color: '#8B5CF6'
  },
  {
    step: '04',
    icon: TrendingUp,
    title: 'Разработка стратегии',
    subtitle: 'Персональный план возврата средств',
    description: 'На основе собранных данных мы формируем индивидуальную многоуровневую стратегию возврата с учетом всех банковских, финансовых и репутационных рычагов давления.',
    actions: [
      'Определение оптимального типа возврата (полный/частичный)',
      'Планирование претензий и переговоров с банками',
      'Подготовка к работе с регуляторами (FCA, CySEC, ASIC и др.)',
      'Стратегия взыскания через банковские процедуры',
      'План работы с платежными системами и банками',
      'Расчет прогнозируемых сроков и вероятности успеха'
    ],
    duration: '1-2 дня',
    color: '#EC4899'
  },
  {
    step: '05',
    icon: FileCheck,
    title: 'Оформление документов',
    subtitle: 'Подготовка документации международного уровня',
    description: 'Наши специалисты готовят полный пакет документов на языках всех задействованных стран, обеспечивая максимальную силу претензий к банкам и платформам.',
    actions: [
      'Составление официальной претензии/claim letter',
      'Подготовка заявлений в регуляторные органы',
      'Оформление chargeback-запросов через банки',
      'Подготовка претензии в банк (при необходимости)',
      'Нотариальное заверение документов',
      'Перевод на необходимые языки с апостилем'
    ],
    duration: '2-3 дня',
    color: '#06B6D4'
  },
  {
    step: '06',
    icon: CreditCard,
    title: 'Активная фаза возврата',
    subtitle: 'Многоканальное взыскание средств',
    description: 'Запускаем параллельные процессы взыскания по всем доступным каналам: прямые переговоры, работа с регуляторами, chargeback, банковские процедуры и международные запросы.',
    actions: [
      'Направление официальных претензий ответчику',
      'Подача жалоб в регуляторы (FCA, SEC, ESMA и др.)',
      'Инициация chargeback через платежные системы',
      'Переговоры с брокером/платформой о мирном урегулировании',
      'Работа с банками по возврату средств',
      'Работа с правоохранительными органами',
      'Заморозка активов через банковские каналы'
    ],
    duration: '1-4 недели',
    color: '#10B981'
  },
  {
    step: '07',
    icon: Bell,
    title: 'Получение и перевод средств',
    subtitle: 'Контроль возврата денег клиенту',
    description: 'Как только средства получены от ответчика, мы организуем их быстрый и безопасный перевод на ваши реквизиты, информируя вас о каждом этапе транзакции.',
    actions: [
      'Получение средств от ответчика/регулятора/банка',
      'Верификация полноты возвращенной суммы',
      'Подготовка документов на перевод клиенту',
      'Безопасный перевод через проверенные каналы',
      'Предоставление клиенту всех платежных документов',
      'Уведомление о завершении транзакции'
    ],
    duration: '2-5 дней',
    color: '#F59E0B'
  },
  {
    step: '08',
    icon: Archive,
    title: 'Закрытие и отчетность',
    subtitle: 'Финализация кейса и аналитика',
    description: 'Мы завершаем кейс, предоставляя вам полный финальный отчет со всеми документами, и анализируем процесс для постоянного улучшения нашего сервиса.',
    actions: [
      'Формирование итогового отчета о проделанной работе',
      'Предоставление всех документов клиенту',
      'Архивирование кейса в защищенном хранилище',
      'Анализ причин мошенничества для профилактики',
      'Сбор обратной связи от клиента',
      'Внутренний анализ для улучшения процессов'
    ],
    duration: '1-2 дня',
    color: '#8B5CF6'
  }
];

const DetailedProcessSection = () => {
  return (
    <section id="detailed-process" className="detailed-process-section">
      <div className="section-container">
        <div className="section-header centered">
          <h2 className="section-title">Детальный процесс возврата средств</h2>
          <p className="section-subtitle">
            8 этапов профессионального возврата с полным сопровождением через банковские процедуры
          </p>
        </div>

        <div className="process-stats-banner">
          <div className="process-stat-item">
            <Clock size={28} />
            <div>
              <div className="stat-number">1-4 недели</div>
              <div className="stat-text">Средний срок возврата</div>
            </div>
          </div>
          <div className="process-stat-item">
            <Shield size={28} />
            <div>
              <div className="stat-number">87%</div>
              <div className="stat-text">Успешность</div>
            </div>
          </div>
          <div className="process-stat-item">
            <TrendingUp size={28} />
            <div>
              <div className="stat-number">$10.4M+</div>
              <div className="stat-text">Возвращено</div>
            </div>
          </div>
        </div>

        <div className="detailed-process-timeline">
          {detailedProcess.map((item, index) => {
            const IconComponent = item.icon;
            return (
              <div key={index} className="detailed-process-item">
                <div className="process-item-header">
                  <div className="process-step-indicator" style={{ borderColor: item.color }}>
                    <span style={{ color: item.color }}>{item.step}</span>
                  </div>
                  <div 
                    className="process-icon-wrapper" 
                    style={{ 
                      background: `${item.color}15`,
                      borderColor: `${item.color}40`
                    }}
                  >
                    <IconComponent size={32} style={{ color: item.color }} />
                  </div>
                </div>

                <div className="process-item-content">
                  <div className="process-item-title-row">
                    <h3 className="process-item-title">{item.title}</h3>
                    <div className="process-duration" style={{ color: item.color }}>
                      <Clock size={16} />
                      {item.duration}
                    </div>
                  </div>
                  <p className="process-item-subtitle">{item.subtitle}</p>
                  <p className="process-item-description">{item.description}</p>
                  
                  <div className="process-actions">
                    <h4 className="actions-title">Что мы делаем:</h4>
                    <ul className="actions-list">
                      {item.actions.map((action, idx) => (
                        <li key={idx} className="action-item">
                          <CheckCircle size={16} style={{ color: item.color }} />
                          <span>{action}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {index < detailedProcess.length - 1 && (
                  <div className="process-connector" style={{ background: item.color }}></div>
                )}
              </div>
            );
          })}
        </div>

        <div className="process-cta-block">
          <h3 className="cta-title">Готовы начать процесс возврата?</h3>
          <p className="cta-text">
            Получите бесплатную консультацию и оценку перспектив вашего кейса от наших экспертов
          </p>
          <button 
            className="btn-primary btn-large"
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
          >
            Начать возврат средств
          </button>
        </div>
      </div>
    </section>
  );
};

export default DetailedProcessSection;